import ArrowIconOpen from './component.jsx'
export default ArrowIconOpen
